import { ToolBase, ToolDescription } from "../../../agents/base";
import { createTelemetry, resolveSessionId, unwrapRequest, } from "../readHelpers";
import { ReadFormattingParamsSchema, } from "./readFormatting.schema";
const SYSTEM_PROMPT_DESCRIPTION = `### readFormatting
Read worksheet formatting grouped into sharedFormatRanges for the target range.`;
export function createReadFormattingTool(runner, fallbackSessionId) {
    return new ReadFormattingTool(runner, fallbackSessionId).toRuntimeToolDefinition();
}
export class ReadFormattingTool extends ToolBase {
    constructor(runner, fallbackSessionId) {
        super();
        this.runner = runner;
        this.fallbackSessionId = fallbackSessionId;
        this.name = "readFormatting";
        this.description = new ToolDescription("readFormatting", "Read worksheet formatting grouped into sharedFormatRanges for the target range.", ReadFormattingParamsSchema);
        this.paramsSchema = ReadFormattingParamsSchema;
        this.systemPromptDescription = SYSTEM_PROMPT_DESCRIPTION;
    }
    setSessionId(sessionId) {
        this.fallbackSessionId = sessionId;
    }
    async execute(args) {
        const startedAt = Date.now();
        const sessionId = resolveSessionId(args, this.fallbackSessionId);
        const request = unwrapRequest(args);
        const readFormatting = request.readFormatting || [];
        const result = await this.runner.read({ readFormatting }, { sessionId });
        const payload = (result.data || {});
        const readFormattingResult = payload.readFormatting || [];
        return {
            ...result,
            data: { readFormatting: readFormattingResult },
            results: { readFormatting: readFormattingResult },
            telemetry: result.telemetry || createTelemetry(readFormatting.length, startedAt),
        };
    }
}
